import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, signal, ViewChild} from '@angular/core';
import RappidService from "../../services/jointjs/logigramme-service";
import {StencilService} from "../../services/jointjs/stencil-service";
import {ToolbarService} from "../../services/jointjs/toolbar-service";
import {InspectorService} from "../../services/jointjs/inspector-service";
import {HaloService} from "../../services/jointjs/halo-service";
import {KeyboardService} from "../../services/jointjs/keyboard-service";
import { Router } from "@angular/router";
import {ProceduresService} from "../../services/procedures/procedures.service";
import {AnnexesService} from "../../services/annexes/annexes.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Subscription} from "rxjs";
import {MatChip} from "@angular/material/chips";
import {NgClass} from "@angular/common";

@Component({
  selector: 'logigramme-read-only',
  templateUrl: './logigramme-read-only.component.html',
  standalone: true,
  imports: [
    MatChip,
    NgClass
  ],
  styleUrl: './logigramme-read-only.component.scss'
})
export class LogigrammeReadOnlyComponent implements OnInit, OnDestroy {

  @ViewChild('logigramme_container' , { static: false }) logigrammeContainer: ElementRef;
  @Input() procedureId : string
  @Input() showDetails: boolean;

  @Output() rappidEventEmitter = new EventEmitter<RappidService>();

  procedure: {
    titre: string,
    version: number,
    category: {
      libelle: string,
    },
    etat: {
      libelle: string,
    },
    logigramme : any
  };
  getProcedureByIdSubscription: Subscription;

  // Join JS
  private rappid: RappidService


  constructor(
    private router: Router,
    private proceduresService: ProceduresService,
    private annexeService: AnnexesService,
    private _snackBar: MatSnackBar
  ) {
  }

  ngOnInit(): void {
    if(this.procedureId) {
      this.getProcedureById(this.procedureId);
    }
  }

  getProcedureById(id: string) {
    try {
      this.getProcedureByIdSubscription = this.proceduresService.getProcedureById(id).subscribe((procedure) => {
        if(procedure) {
          this.procedure = procedure.data;
          this.rappid = new RappidService(
            this.logigrammeContainer.nativeElement,
            new StencilService(),
            new ToolbarService(),
            new InspectorService(this.proceduresService, this.annexeService, this.procedure.logigramme),
            new HaloService(),
            new KeyboardService(),
            true
          );
          this.rappid.startRappid();
          if (this.procedure.logigramme && Object.keys(this.procedure.logigramme).length > 0) {
            this.rappid.graph.fromJSON(this.procedure.logigramme);
            this.rappid.paper.setGrid(false);
            // vu qu'on est en readOnly, on met le cursor à auto dans le paper et pointer dans les cells (ce dernier est géré en bas dans la méthode handleHoverEvents).
            this.rappid.paperScroller.setCursor("auto");

            // vu qu'on ne veut pas d'interaction sur cette vue, on utilise on disable toute sorte d'interaction.
            this.rappid.paper.setInteractivity(false);

            // une fois l'objet rappid rempli, on l'envoie au composant parent
            this.rappidEventEmitter.emit(this.rappid);

            // Une fois le logigramme construit, on ajoute le handler des clicks events et les hovers events.
            this.handleClickEvents();
            this.handleHoverEvents();


          }
        }
      })
    } catch(error: any) {
      this.openSnackBar(error?.message ? error?.message : 'Une erreur est survenue.');
    }
  }

  handleClickEvents() {
    this.rappid.paper.on('cell:pointerclick', (cellView) => {
      const cell = cellView.model;
      // On récupère l'id de l'element auquel on veut scroll
      const elementDiagrammeIdToScrollTo = cell.prop('attrs/label/elementDiagrammeSearch') || '';
      const procedureIdToOpenInNewTab = cell.prop('attrs/label/procedureSearch') || '';

      // si c'est un goTo Element on scroll vers l'élément souhaité sinon si c'est une procédure, on l'ouvre dans un nouvel onglet
      if(elementDiagrammeIdToScrollTo) {
        //via l'id on recupére l'objet cell
        let cellToScrollTo = this.procedure.logigramme.cells.find((cell: any) => cell.id == elementDiagrammeIdToScrollTo);
        if(cellToScrollTo) {
          let x = cellToScrollTo.position.x;
          let y = cellToScrollTo.position.y;

          this.rappid.paperScroller.scroll(x, y);
        }
      } else if (procedureIdToOpenInNewTab) {
        const url = this.router.serializeUrl(
          this.router.createUrlTree([`/procedures/modifier-procedure/${procedureIdToOpenInNewTab}`])
        );
        window.open(url, '_blank');
      }

    });
  }

  handleHoverEvents() {
    this.rappid.paper.on('cell:mouseover', (cellView) => {
      // par default, on met le cursor à auto, le cas d'une cell clickable est gérée aprés
      cellView.el.style.cursor = 'auto';

      const cell = cellView.model;
      // On récupère l'id de l'élément auquel on veut scroll ou de la procédure à ouvrir dans un nouvel onglet
      const elementDiagrammeIdToScrollTo = cell.prop('attrs/label/elementDiagrammeSearch') || '';
      const procedureIdToOpenInNewTab = cell.prop('attrs/label/procedureSearch') || '';
      if(elementDiagrammeIdToScrollTo || procedureIdToOpenInNewTab ) {
        cellView.el.style.cursor = 'pointer';
      }
    })
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, "Fermer", {
      duration: 5000,
    });
  }

  ngOnDestroy(): void {
    this.getProcedureByIdSubscription?.unsubscribe();
  }

}
